import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import Illustration from '../../components/Illustration';

const InactiveUserPage: FunctionComponent = () => (
  <div className="h-100 t-18 d-flex align-items-center justify-content-center">
    <Illustration
      variant="sitting"
      height="60vh"
      description={(
        <FormattedMessage
          id="inactiveAccError"
          defaultMessage="This account is inactive. Please contact your administrator"
        />
      )}
    />
  </div>
);

export default InactiveUserPage;
